/**
 * dev  : zhihuaw
 * desc : 榜单聚合页代理层组件
 * props: compProps、compIndex
 * emit : init：初始化数据；finish：数据改变触发
 */
<template>
  <section :id="`comp_id_${compProps.elementId}`">
    <component :is="compName" :topListData="compProps.mate" :payLoad="payLoad" :houseData="houseData" :compId="(compProps.elementId + '')" @action="actionHandle"></component>
    <component :is="servCompName" :compProps="compProps" :payLoad="actionVal" :compIndex="compIndex" @init="initHandle" @finish="finishHandle"></component>
  </section>
</template>
<script>
import TopList from '@/components/TopList'
import serviceComps from './../serviceComps'
import mixin from '@/mixin/compMixin.js'

export default {
  mixins: [mixin],
  components: {
    TopList,
    ...serviceComps
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  data() {
    return {
      // 房屋列表详情
      houseData: [],
      // 收藏关注集合
      payLoad: {},
      // ui组件action的payload值
      actionVal: {}
    }
  },
  computed: {
    compName() {
      return 'topList'
    }
  },
  methods: {
    /**
     * 初始化接口，用于获得业务组件的初始化数据
     */
    initHandle(payLoad) {
      this.houseData = payLoad
    },
    /**
     * UI交互组件对用户的交互派发接口，将UI组件用户交互的事件信息发送给业务组件
     */
    actionHandle(payLoad) {
      this.actionVal = payLoad
    },
    /**
     * 当业务组件处理完用户的交互动作后，将结果通过这个接口返回给Ui组件
     * 不要嫌麻烦，这样做的目的是彻底剥离业务与视图，达到视图和业务的自由组合目的
     */
    finishHandle(payLoad) {
      this.payLoad = payLoad
    }
  }
}
</script>
